import { LoadingContainer } from "@/lib/loading/container"
import { LoadingContext } from "@/lib/loading/context"
import { curryOnMaybeReady as curryOnMaybeReadyFn } from "@/lib/loading/curryOnMaybeReady"
import { dependenciesReady as dependenciesReadyFn } from "@/lib/loading/dependenciesReady"
import { processIsReady as processIsReadyFn } from "@/lib/loading/processIsReady"
import { processJustLoaded as processJustLoadedFn } from "@/lib/loading/processJustLoaded"
import { LoadingScreen } from "@/lib/loading/screen"
import { shouldComponentReady as shouldComponentReadyFn } from "@/lib/loading/shouldComponentReady"

export namespace Loading {
  export type ContextData = {
    processes: Processes
    ready: boolean
    update: Functions.Update
  }

  export type Config = {
    dependencies: ProcessId[]
    processId: ProcessId
    readying?: boolean
  }

  export type Process = { loading: boolean }

  export type ProcessId =
    | `appointments`
    | `authentication`
    | `background`
    | `bookingSearch`
    | `bookingSource`
    | `caching`
    | `geolocation`
    | `notices`
    | `routing`
    | `services`

  export type Processes = Record<ProcessId, Process>

  export const Container = LoadingContainer

  export const Context = LoadingContext

  export const Screen = LoadingScreen

  export const curryOnMaybeReady = curryOnMaybeReadyFn

  export const shouldComponentReady = shouldComponentReadyFn

  export const dependenciesReady = dependenciesReadyFn

  export const processIsReady = processIsReadyFn

  export const processJustLoaded = processJustLoadedFn

  export type StillLoading = boolean

  export namespace Functions {
    export type OnLoadHandler<Props> = (props: Props) => Promise<void> | void

    export type OnMaybeReady = () => Promise<StillLoading> | StillLoading

    export type Update = (args: Partial<Record<ProcessId, Process>>) => void
  }
}
